import { type QueryClient } from '@tanstack/react-query';

import { getCurrentPlanOptions } from '@/api/gen/quiz-plans/quiz-plans.gen';
import { getGetMyVouchersQueryKey } from '@/api/gen/vouchers/vouchers.gen';
import { UseSubscribeUserPlanKey } from '@/lib/auth';
import {
  checkPlanChangedAndReset,
  planExpirationAlertStorage,
  planStartAlertStorage,
} from '@/module/plan/storage';

/** 이용권 활성화 직후 플랜·이용권 UI가 같은 서버 상태를 보게 한다. */
export const refreshVoucherActivationState = (
  queryClient: QueryClient,
  options: { suppressPlanStartModalForUserId?: string } = {},
) => {
  const userId = options.suppressPlanStartModalForUserId;
  const refreshPlan = userId
    ? queryClient
        .fetchQuery({
          queryKey: UseSubscribeUserPlanKey,
          queryFn: () => getCurrentPlanOptions(),
          staleTime: 0,
        })
        .then(({ data }) => {
          if (data.plan.planStatus !== 'ACTIVE' || !data.workspace) return;
          // 전역 구독과 같은 플랜 identity를 먼저 맞춰 늦게 실행되는 effect의 재초기화를 막는다.
          // 다음 결제에 남는 억제 예약 없이, 실제 활성화된 플랜만 확인 처리한다.
          checkPlanChangedAndReset(
            {
              userId,
              workspaceHashId: data.workspace.hashId,
              quizPlanType: data.plan.planType,
              startDate: data.plan.startDate,
              endDate: data.plan.endDate,
            },
            [planExpirationAlertStorage, planStartAlertStorage],
          );
          planStartAlertStorage.markAsShown();
        })
    : queryClient.refetchQueries({ queryKey: UseSubscribeUserPlanKey });

  return Promise.allSettled([
    refreshPlan,
    queryClient.invalidateQueries({ queryKey: getGetMyVouchersQueryKey() }),
  ]);
};
